import { useEffect, useState } from "react";
import { Headphones } from "lucide-react";
import { endpoints } from "@/lib/api";
import { Card } from "./AdminUI";

// Admin: live radio listeners now + today's peak + last 7 days.
export function RadioListenerStats() {
  const [d, setD] = useState(null);
  useEffect(() => {
    const load = () => endpoints.adminRadioListeners().then((r) => setD(r.data)).catch(() => {});
    load();
    const t = setInterval(load, 30000);
    return () => clearInterval(t);
  }, []);
  if (!d) return null;
  const max = Math.max(1, ...d.last7.map((x) => x.peak));
  return (
    <Card className="p-5 mb-6 flex flex-wrap items-center gap-6" data-testid="admin-radio-listeners">
      <div className="flex items-center gap-3"><Headphones className="w-8 h-8 text-[#E11D2A]" />
        <div><div className="text-3xl font-extrabold text-white tabular-nums" data-testid="admin-radio-now">{d.listening}</div><div className="text-xs text-slate-400">listening now</div></div></div>
      <div><div className="text-2xl font-bold text-white tabular-nums" data-testid="admin-radio-peak">{d.today.peak}</div>
        <div className="text-xs text-slate-400">today's peak{d.today.peakAt ? ` · ${new Date(d.today.peakAt).toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" })}` : ""}</div></div>
      <div className="flex items-end gap-1.5 h-12 ml-auto" aria-label="Peak listeners last 7 days">
        {[...d.last7].reverse().map((x) => (
          <div key={x.date} className="flex flex-col items-center gap-1" title={`${x.date}: ${x.peak}`}>
            <div className="w-5 rounded-t bg-[#E11D2A]/70" style={{ height: `${Math.max(3, (x.peak / max) * 40)}px` }} />
            <span className="text-[9px] text-slate-500">{x.date.slice(8)}</span>
          </div>
        ))}
      </div>
    </Card>
  );
}
